import { id, role } from "@planzone/dto";
import { HttpClient } from "../types/httpClient";

function getZoneRole(httpClient: HttpClient) {
  return () => Promise.resolve({ ...role, uuid: id });
}

export { getZoneRole };
